// 由三个部分组成的页面外壳
import routerViewIndustry from '@/views/layout/routerViewIndustry.vue'

export const industryChainRoute = [
  {
    path: 'industryChain',
    name: '产业获客',
    component: () => import('@/views/industryChainNew/page/index'),
    icon: 'icon-shouyefill',
    icon_img: 'nav01',
    hidden: false,
    meta: {
      nextStart: true,
      title: '产业获客',
    }
  },
  {
    path: 'industryChain',
    name: '产业获客',
    component: routerViewIndustry,
    hidden: true,
    hide: true,
    full: false,
    children: [
      {
        path: 'overview',
        components: {
          header: () => import('@/views/industryChainNew/components/headCondition'),
          default: () => import('@/views/industryChainNew/page/industryOverview'),
        },
        name: '产业概况',
        hidden: false,
        hide: true,
        meta: {
          title: '产业概况',
          icon: 'leftIcon3',
          breadcrumb: ['产业获客', '产业概况'],
          highlight: '/zxk/industryChain'
        }
      },
      {
        path: 'map',
        components: {
          header: () => import('@/views/industryChainNew/components/headCondition'),
          default: () => import('@/views/industryChainNew/page/industryMap'),
        },
        name: '产业图谱',
        hidden: false,
        hide: true,
        meta: {
          title: '产业图谱',
          icon: 'leftIcon3',
          breadcrumb: ['产业获客', '产业图谱'],
          highlight: '/zxk/industryChain'
        }
      },
      {
        path: 'analyze',
        components: {
          header: () => import('@/views/industryChainNew/components/headCondition'),
          default: () => import('@/views/industryChainNew/page/industryAnalyze'),
        },
        name: '产业分析',
        hidden: false,
        hide: true,
        meta: {
          title: '产业分析',
          icon: 'leftIcon3',
          breadcrumb: ['产业获客', '产业分析'],
          highlight: '/zxk/industryChain'
        }
      },
      {
        path: 'distribution',
        components: {
          header: () => import('@/views/industryChainNew/components/headCondition'),
          default: () => import('@/views/industryChainNew/page/industryDistribution'),
        },
        name: '企业分布',
        hidden: false,
        hide: true,
        meta: {
          title: '企业分布',
          icon: 'leftIcon3',
          breadcrumb: ['产业获客', '企业分布'],
          highlight: '/zxk/industryChain'
        }
      },
      {
        path: 'news',
        components: {
          header: () => import('@/views/industryChainNew/components/headCondition'),
          default: () => import('@/views/industryChainNew/page/industryNews'),
        },
        name: '产业新闻',
        hidden: false,
        hide: true,
        meta: {
          title: '产业新闻',
          icon: 'leftIcon3',
          breadcrumb: ['产业获客', '产业新闻'],
          highlight: '/zxk/industryChain'
        }
      },
      {
        path: 'policy',
        components: {
          header: () => import('@/views/industryChainNew/components/headCondition'),
          default: () => import('@/views/industryChainNew/page/industryPolicy'),
        },
        name: '产业政策',
        hidden: false,
        hide: true,
        meta: {
          title: '产业政策',
          icon: 'leftIcon3',
          breadcrumb: ['产业获客', '产业政策'],
          highlight: '/zxk/industryChain'
        }
      },

      // {
      //   path: 'index',
      //   component: () => import('@/views/industryChainNew/page/index'),
      //   name: '产业链',
      //   hidden: false,
      //   hide: false,
      //   meta: {
      //     // nextStart: true,
      //     // keepAlive: true,
      //     title: '产业链',
      //     icon: 'leftIcon3',
      //     breadcrumb: ['产业获客', '产业链']
      //   }
      // },
      // {
      //   path: 'strategy',
      //   components: {
      //     header: () => import('@/views/industryChainNew/components/strategyHeadCondition'),
      //     default: () => import('@/views/industryChainNew/page/strategyIndex')
      //   },
      //   name: '国家战略',
      //   hidden: false,
      //   hide: false,
      //   meta: {
      //     // nextStart: true,
      //     // keepAlive: true,
      //     title: '国家战略',
      //     icon: 'leftIcon3',
      //     breadcrumb: ['产业获客', '国家战略']
      //   }
      // },
      // {
      //   path: 'greenFinance',
      //   components: {
      //     header: () => import('@/views/industryChainNew/components/strategyHeadCondition'),
      //     default: () => import('@/views/industryChainNew/page/strategyIndex')
      //   },
      //   name: '绿色金融',
      //   hidden: false,
      //   hide: true,
      //   meta: {
      //     // nextStart: true,
      //     // keepAlive: true,
      //     title: '绿色金融',
      //     icon: 'leftIcon3',
      //     breadcrumb: ['产业获客', '国家战略']
      //   }
      // },
      // {
      //   path: 'ruralRevitalization',
      //   components: {
      //     header: () => import('@/views/industryChainNew/components/strategyHeadCondition'),
      //     default: () => import('@/views/industryChainNew/page/strategyIndex')
      //   },
      //   name: '乡村振兴',
      //   hidden: false,
      //   hide: true,
      //   meta: {
      //     // nextStart: true,
      //     // keepAlive: true,
      //     title: '乡村振兴',
      //     icon: 'leftIcon3',
      //     breadcrumb: ['产业获客', '国家战略']
      //   }
      // },
      // {
      //   path: 'infrastructure',
      //   components: {
      //     header: () => import('@/views/industryChainNew/components/strategyHeadCondition'),
      //     default: () => import('@/views/industryChainNew/page/strategyIndex')
      //   },
      //   name: '新基建',
      //   hidden: false,
      //   hide: true,
      //   meta: {
      //     // nextStart: true,
      //     // keepAlive: true,
      //     title: '新基建',
      //     icon: 'leftIcon3',
      //     breadcrumb: ['产业获客', '国家战略']
      //   }
      // },
      // {
      //   path: 'manufacturing',
      //   components: {
      //     header: () => import('@/views/industryChainNew/components/strategyHeadCondition'),
      //     default: () => import('@/views/industryChainNew/page/strategyIndex')
      //   },
      //   name: '制造业2025',
      //   hidden: false,
      //   hide: true,
      //   meta: {
      //     // nextStart: true,
      //     // keepAlive: true,
      //     title: '制造业2025',
      //     icon: 'leftIcon3',
      //     breadcrumb: ['产业获客', '国家战略']
      //   }
      // },
    ]
  }
]

export default industryChainRoute
